import { initializeApp } from "firebase/app";
import { getAuth, inMemoryPersistence, setPersistence } from "firebase/auth";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAAsmx0CSxsI4Sdc2czky7dd26Y1N8ebpU",
  authDomain: "meetly-31e2f.firebaseapp.com",
  projectId: "meetly-31e2f",
  storageBucket: "meetly-31e2f.firebasestorage.app",
  messagingSenderId: "852508372786",
  appId: "1:852508372786:web:5caab8027d64de4b87b12b",
  measurementId: "G-M2KHL493RG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth en memoria para evitar escrituras lentas en disco
export const auth = getAuth(app);
setPersistence(auth, inMemoryPersistence).catch((err) => console.warn(err));

// Firestore con caché en memoria pura (sin intentar reconexiones pesadas en red)
export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
});
